// extracted by mini-css-extract-plugin
module.exports = {"links":"AlbumDetailsLinks-links-352IQ","link":"AlbumDetailsLinks-link-7z0sF","linkLabel":"AlbumDetailsLinks-linkLabel-Z1ZmN Label-label-30Bqv"};